'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _bemit = _interopRequireDefault(require("Functions/bemit"));
const _excluded = ["children"];
const RenderEditorText = /*#__PURE__*/_react.default.memo(function RenderEditorText(_ref) {
  let {
    str = ''
  } = _ref;
  let json = {};
  try {
    json = JSON.parse(str);
  } catch (e) {
    return null;
  }
  const output = /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _bemit.default)('c-rendered-editor-txt')
  }, json._nodeMap.map(function (_ref2) {
    let [key, obj] = _ref2;
    const {
      __key,
      __type,
      __text
    } = obj;

    //console.log(obj);

    if (__type === 'root') return null;
    let Component = Components[__type];
    if (!Component && __text) Component = Text;
    if (!Component) return null;
    const output = /*#__PURE__*/_react.default.createElement(Component, {
      key: __key
    }, __text);
    return output;
  }));
  return output;
});
var _default = exports.default = RenderEditorText;
const Components = {
  'text': Text,
  'linebreak': Br
};
function Text(_ref3) {
  let {
      children
    } = _ref3,
    props = (0, _objectWithoutProperties2.default)(_ref3, _excluded);
  const output = /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({}, props, {
    className: "c-rendered-editor-txt__text"
  }), children);
  return output;
}
function Br() {
  return /*#__PURE__*/_react.default.createElement("br", null);
}
